module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot02_stay-c81564f188271e2b80bf5f7a68595507.jpg";